import React, { useState } from 'react';
import { MdDownloadDone } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import Tooltip from '../tooltip';

interface DownloadActionProps {
  onDownload?: () => void;
  data?: any;
  messageId?: string;
  fileName?: string;
  fileFormat?: 'json' | 'csv' | 'xlsx' | 'txt';
  className?: string;
}

const DownloadAction: React.FC<DownloadActionProps> = ({
  onDownload,
  fileFormat = 'CSV',
  className = ''
}) => {
  const [downloading, setDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);

  const handleDownload = () => {
    if (onDownload) {
      onDownload();
    }
  };

  return (
    <Tooltip message={`Export data (${fileFormat.toUpperCase()})`}>
      <button
        type="button"
        onClick={handleDownload}
        className={`p-2 group flex items-center justify-center rounded-full transition-colors active:text-primary text-primary-text hover:bg-secondary-background hover:text-primary ${className}`}
      >
        {downloading ? (
          <div className="w-5 h-5 animate-spin">
            <svg className="w-full h-full" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.25"></circle>
              <path className="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        ) : downloaded ? (
          <MdDownloadDone className="w-5 h-5 text-green-600" strokeWidth={1.75}/>
        ) : (
          <FiDownload className="w-5 h-5" strokeWidth={1.75}/>
        )}
      </button>
    </Tooltip>
  );
};

export default DownloadAction;